import { Component, OnDestroy, OnInit } from '@angular/core';
import { WindowReferenceService, ICustomWindow } from '@core/shared';
import { PreloginService } from '@core/prelogin/services/prelogin.service';
import { forkJoin, Subscription } from 'rxjs';
import { browserRefresh } from '@app/app.component';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { NavigationEnd, Router, RouterEvent } from '@angular/router';
import { filter, startWith } from 'rxjs/operators';
import { hierarchyGroup, uniqueFieldValidation, userAddress } from '@app/extension/models/userAddressDetail.model';
import swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import Swal from 'sweetalert2';
let windowObject = window as any;

@Component({
    selector: 'app-account-register',
    templateUrl: './account-register.component.html',
    styleUrls: ['./account-register.component.scss']
})
export class AccountRegisterComponent implements OnInit, OnDestroy {
    private _window: ICustomWindow;
    lstcomments: any;
    showLoginPageLink: boolean = false;
    selectedCulture: string;
    languageChangeSubscription: Subscription;
    navigationStartSubscription: Subscription;
    browserRefresh: boolean;
    jobRoleList: any;
    programName: any;

    constructor(public PreloginService: PreloginService, public windowRef: WindowReferenceService, private translateService: TranslateService,
        private router: Router) {
        this._window = windowRef.nativeWindow;
    }

    ngOnInit(): void {
        this.PreloginService.getJobRoles().subscribe(res => {
            this.jobRoleList = res;
            sessionStorage.setItem("JobRoles", JSON.stringify(res));
        });

        this.PreloginService.getUserProgramName('', window.location.host, '').subscribe(res => {
            this.programName = res.participantProgramDetails.programName;
        })


        windowObject.parent.preloginService = this.PreloginService;
        windowObject.parent.translate = this.translateService;
        windowObject.parent.preRegistrationCallBack = function (userDetails): Promise<any> {
            let panObject: any = Object.values(userDetails).find(x => x["fieldName"] == "PAN Number");
            let gstObject: any = Object.values(userDetails).find(x => x["fieldName"] == "GST Number");
            let addressObject: any = Object.values(userDetails).find(x => x["fieldName"] == "Address");
            let jobRolebject: any = Object.values(userDetails).find(x => x["fieldName"] == "Job Role");
            let emailObject: any = Object.values(userDetails).find(x => x["fieldName"] == "EmailAddress");
            let mobileObject: any = Object.values(userDetails).find(x => x["fieldName"] == "Mobile Phone");
            let campaignObject: any = Object.values(userDetails).find(x => x["fieldName"] == "Campaign Name");
            let userObject: any = Object.values(userDetails).find(x => x["fieldName"] == "User Name");
            let organisationObject: any = Object.values(userDetails).find(x => x["fieldName"] == "Firm Name");
            let referralCode: any = Object.values(userDetails).find(x => x["fieldName"] == "Referral Code");

            const promise = new Promise((resolve, reject) => {
                var random = Math.floor(Math.random() * Math.floor(100000000));
                var response = {
                    "success": true,
                    "errorCode": "",
                    "responseMessage": "",
                    "customAttributes": {

                    }
                };
                let isError = false; let errorMsg = '';
                let region = ''; let district = ''; let hierarchyGroupId = '';
                let programName = sessionStorage.getItem("programName");
                let campaignId: any = '';



                if (jobRolebject) {
                    this.jobRoleList = JSON.parse(sessionStorage.getItem("JobRoles"));
                    let jobRoleId = jobRolebject.fieldValue.toUpperCase();
                    let jobRoleName = this.jobRoleList.listViews.find(x => x.value.toUpperCase() == jobRoleId)?.name;
                    if (jobRoleName == 'Distributor' || jobRoleName == 'Channel Partner') {

                        if (!panObject || panObject.fieldValue == "") {
                            isError = true;
                            errorMsg = windowObject.parent.translate.instant("SelfRegistration.PANRequired");
                            // response.success = false;
                            // response.responseMessage = windowObject.parent.translate.instant("SelfRegistration.PANRequired");
                            // reject(response);
                        }
                        else if (!gstObject || gstObject.fieldValue == "") {
                            isError = true;
                            errorMsg = windowObject.parent.translate.instant("SelfRegistration.GSTRequired");
                            // response.success = false;
                            // response.responseMessage = windowObject.parent.translate.instant("SelfRegistration.GSTRequired");
                            // reject(response);
                        }
                    } else if (jobRoleName == 'Retailer' || jobRoleName == 'Sub Dealer' ||
                        jobRoleName == 'Contractor' || jobRoleName == 'Store Manager' ||
                        jobRoleName == 'Service Advisors' || jobRoleName == 'Car Dealership Centre' ||
                        jobRoleName == 'Dealership Manager' || jobRoleName == 'Supervisor') {
                        if (!panObject || panObject.fieldValue == "") {
                            isError = true;
                            errorMsg = windowObject.parent.translate.instant("SelfRegistration.PANRequired");
                            // response.success = false;
                            // response.responseMessage = windowObject.parent.translate.instant("SelfRegistration.PANRequired");
                            // reject(response);
                        }
                    }
                } else {
                    isError = true;
                    errorMsg = windowObject.parent.translate.instant("SelfRegistration.JobRoleRequired");
                }

                if (!isError && addressObject) {
                    // debugger;
                    let model = new userAddress();
                    model.city = addressObject.value.city;
                    model.state = addressObject.value.state;

                    let uniqueValidate = new uniqueFieldValidation();
                    uniqueValidate.programName = programName;
                    uniqueValidate.gstNumber = gstObject ?.fieldValue;
                    uniqueValidate.panNumber = panObject ?.fieldValue;
                    uniqueValidate.mobileNumber = mobileObject ?.fieldValue.phoneNumber;
                    uniqueValidate.eMailId = emailObject ?.fieldValue;
                    uniqueValidate.userName = userObject ?.fieldValue;
                  
                    if (programName == 'aad') {
                        campaignId = campaignObject != undefined ? campaignObject.fieldValue : '';
                        forkJoin({
                            address: windowObject.parent.preloginService.getUserAddressDetails(model), //observable 1
                            campaign: windowObject.parent.preloginService.getJobRoleDataByCampaignId(campaignId),
                            uniqueCheck: windowObject.parent.preloginService.checkUniqueDataValidation(uniqueValidate)
                        }).subscribe(({ address, campaign, uniqueCheck }) => {
                            let addressResponse: any = address;
                            let hierarchyResponse: any  //hierarchy;
                            let jobRoleResponse: any = campaign;

                            if (addressResponse.listViews.length > 0) {
                                district = addressResponse.listViews.find(x => x.name == 'District').value;
                                region = addressResponse.listViews.find(x => x.name == 'Region').value;
                            }

                            windowObject.parent.preloginService.getHierarchyGroupDetails(programName, jobRoleResponse.jobRoleData.id).subscribe(hierarchyApiResponse => {
                                hierarchyResponse = hierarchyApiResponse;

                                if (hierarchyResponse.hierarchyIds.length > 0) {
                                    hierarchyGroupId = hierarchyResponse.hierarchyIds[0];
                                }

                                if (isError) {
                                    response.success = false;
                                    response.responseMessage = errorMsg;
                                    reject(response);
                                } else {
                                    response.customAttributes = {
                                        "CreateOrganisation": "{\"Name\":\"" + organisationObject ?.fieldValue + "\",\"OrganisationCode\":\"Org Code_" + random + "\",\"Online\":true,\"HierarchyGroupId\":\"" + hierarchyGroupId + "\",\"Address1\":\"Line1\",\"Address2\":\"Line2\",\"Address3\":\"Line3\",\"Town\":\"Agra\",\"County\":\"IND\",\"PostCode\":\"451231\",\"CountryIsoCode\":\"IND\",\"Phone\":\"1543215432\",\"Email\":\"dynamicorgcreation@gmail.com\",\"Attributes\":[{\"Name\":\"Attr1\",\"ValueAsString\":\"ValueAsString1\",\"DataType\":\"Text\",\"SortOrder\":\"1\"},{\"Name\":\"Attr2\",\"ValueAsString\":\"ValueAsString2\",\"DataType\":\"Text\",\"SortOrder\":\"2\"}],\"HierarchyGroupIds\":[\"" + hierarchyGroupId + "\"]}",
                                        "Region": region,
                                        "District": district,
                                        "Program Name": programName,
                                        "Job Role": jobRoleResponse.jobRoleData.id,
                                        "Account Status": "Online"
                                    };
                                    response.responseMessage = JSON.stringify(userDetails)
                                    resolve(response);
                                }

                            });

                        },
                            (err) => {
                                response.success = false;
                                if (err.error && err.error.modelState) {
                                    Object.keys(err.error.modelState).forEach(key => {
                                        let errorKey = key.charAt(0).toUpperCase() + key.slice(1)
                                        response.responseMessage = windowObject.parent.translate.instant(errorKey);
                                    });
                                } else {
                                    response.responseMessage = windowObject.parent.translate.instant("SelfRegistration.RequiredFieldValidation");
                                }
                                reject(response);
                            });
                    }
                    else if (programName == "bandhan") {
                        forkJoin({
                            address: windowObject.parent.preloginService.getUserAddressDetails(model), //observable 1
                            hierarchy: windowObject.parent.preloginService.getBandhanHierarchyGroupDetails(programName, jobRolebject.fieldValue,
                                model.city, model.state),
                            uniqueCheck: windowObject.parent.preloginService.checkUniqueDataValidation(uniqueValidate)
                        }).subscribe(({ address, hierarchy, uniqueCheck }) => {
                            let addressResponse: any = address;
                            let hierarchyResponse: any = hierarchy;
                            if (addressResponse.listViews.length > 0) {
                                district = addressResponse.listViews.find(x => x.name == 'District').value;
                                region = addressResponse.listViews.find(x => x.name == 'Region').value;
                            }
                            if (hierarchyResponse.hierarchyIds.length > 0) {
                                hierarchyGroupId = hierarchyResponse.hierarchyIds[0];
                            }

                            if (isError) {
                                response.success = false;
                                response.responseMessage = errorMsg;
                                reject(response);
                            } else {
                                response.customAttributes = {
                                    "CreateOrganisation": "{\"Name\":\"" + organisationObject ?.fieldValue + "\",\"OrganisationCode\":\"Org Code_" + random + "\",\"Online\":true,\"HierarchyGroupId\":\"" + hierarchyGroupId + "\",\"Address1\":\"Line1\",\"Address2\":\"Line2\",\"Address3\":\"Line3\",\"Town\":\"Agra\",\"County\":\"IND\",\"PostCode\":\"451231\",\"CountryIsoCode\":\"IND\",\"Phone\":\"1543215432\",\"Email\":\"dynamicorgcreation@gmail.com\",\"Attributes\":[{\"Name\":\"Attr1\",\"ValueAsString\":\"ValueAsString1\",\"DataType\":\"Text\",\"SortOrder\":\"1\"},{\"Name\":\"Attr2\",\"ValueAsString\":\"ValueAsString2\",\"DataType\":\"Text\",\"SortOrder\":\"2\"}],\"HierarchyGroupIds\":[\"" + hierarchyGroupId + "\"]}",
                                    "Region": region,
                                    "District": district,
                                    "Program Name": programName,
                                    "Registration Status": "Pending With Distributor",
                                    "Account Status": "Online"
                                };
                                response.responseMessage = JSON.stringify(userDetails)
                                resolve(response);
                            }

                        },
                            (err) => {
                                response.success = false;
                                if (err.error && err.error.modelState) {
                                    Object.keys(err.error.modelState).forEach(key => {
                                        let errorKey = key.charAt(0).toUpperCase() + key.slice(1)
                                        response.responseMessage = windowObject.parent.translate.instant(errorKey);
                                    });
                                } else {
                                    response.responseMessage = windowObject.parent.translate.instant("SelfRegistration.RequiredFieldValidation");
                                }
                                reject(response);
                            });
                    }
                    else if(programName == "eliteclubrewards") {
                        forkJoin({
                            address: windowObject.parent.preloginService.getUserAddressDetails(model), //observable 1
                            hierarchy: windowObject.parent.preloginService.getHierarchyGroupDetails(programName, jobRolebject.fieldValue),
                            uniqueCheck: windowObject.parent.preloginService.checkUniqueDataValidation(uniqueValidate)
                        }).subscribe(({ address, hierarchy, uniqueCheck }) => {
                            let addressResponse: any = address;
                            let hierarchyResponse: any = hierarchy;
                            if (addressResponse.listViews.length > 0) {
                                district = addressResponse.listViews.find(x => x.name == 'District').value;
                                region = addressResponse.listViews.find(x => x.name == 'Region').value;
                            }
                            if (hierarchyResponse.hierarchyIds.length > 0) {
                                hierarchyGroupId = hierarchyResponse.hierarchyIds[0];
                            }

                            if (isError) {
                                response.success = false;
                                response.responseMessage = errorMsg;
                                reject(response);
                            } else {
                                response.customAttributes = {
                                    "CreateOrganisation": "{\"Name\":\"" + organisationObject ?.fieldValue + "\",\"OrganisationCode\":\"Org Code_" + random + "\",\"Online\":true,\"HierarchyGroupId\":\"" + hierarchyGroupId + "\",\"Address1\":\"Line1\",\"Address2\":\"Line2\",\"Address3\":\"Line3\",\"Town\":\"Agra\",\"County\":\"IND\",\"PostCode\":\"451231\",\"CountryIsoCode\":\"IND\",\"Phone\":\"1543215432\",\"Email\":\"dynamicorgcreation@gmail.com\",\"Attributes\":[{\"Name\":\"Attr1\",\"ValueAsString\":\"ValueAsString1\",\"DataType\":\"Text\",\"SortOrder\":\"1\"},{\"Name\":\"Attr2\",\"ValueAsString\":\"ValueAsString2\",\"DataType\":\"Text\",\"SortOrder\":\"2\"}],\"HierarchyGroupIds\":[\"" + hierarchyGroupId + "\"]}",
                                    "Region": region,
                                    "District": district,
                                    "Program Name": programName,
                                    "Registration Status": "Pending With PO",
                                    "Account Status": "Online"
                                };
                                response.responseMessage = JSON.stringify(userDetails)
                                resolve(response);
                            }

                        },
                            (err) => {
                                response.success = false;
                                if (err.error && err.error.modelState) {
                                    Object.keys(err.error.modelState).forEach(key => {
                                        let errorKey = key.charAt(0).toUpperCase() + key.slice(1)
                                        response.responseMessage = windowObject.parent.translate.instant(errorKey);
                                    });
                                } else {
                                    response.responseMessage = windowObject.parent.translate.instant("SelfRegistration.RequiredFieldValidation");
                                }
                                reject(response);
                            });
                    }
                    else {
                        forkJoin({
                            address: windowObject.parent.preloginService.getUserAddressDetails(model), //observable 1
                            hierarchy: windowObject.parent.preloginService.getHierarchyGroupDetails(programName, jobRolebject.fieldValue),
                            uniqueCheck: windowObject.parent.preloginService.checkUniqueDataValidation(uniqueValidate)
                        }).subscribe(({ address, hierarchy, uniqueCheck }) => {
                            let addressResponse: any = address;
                            let hierarchyResponse: any = hierarchy;
                            if (addressResponse.listViews.length > 0) {
                                district = addressResponse.listViews.find(x => x.name == 'District').value;
                                region = addressResponse.listViews.find(x => x.name == 'Region').value;
                            }
                            if (hierarchyResponse.hierarchyIds.length > 0) {
                                hierarchyGroupId = hierarchyResponse.hierarchyIds[0];
                            }

                            if (isError) {
                                response.success = false;
                                response.responseMessage = errorMsg;
                                reject(response);
                            } else {
                                response.customAttributes = {
                                    "CreateOrganisation": "{\"Name\":\"" + organisationObject ?.fieldValue + "\",\"OrganisationCode\":\"Org Code_" + random + "\",\"Online\":true,\"HierarchyGroupId\":\"" + hierarchyGroupId + "\",\"Address1\":\"Line1\",\"Address2\":\"Line2\",\"Address3\":\"Line3\",\"Town\":\"Agra\",\"County\":\"IND\",\"PostCode\":\"451231\",\"CountryIsoCode\":\"IND\",\"Phone\":\"1543215432\",\"Email\":\"dynamicorgcreation@gmail.com\",\"Attributes\":[{\"Name\":\"Attr1\",\"ValueAsString\":\"ValueAsString1\",\"DataType\":\"Text\",\"SortOrder\":\"1\"},{\"Name\":\"Attr2\",\"ValueAsString\":\"ValueAsString2\",\"DataType\":\"Text\",\"SortOrder\":\"2\"}],\"HierarchyGroupIds\":[\"" + hierarchyGroupId + "\"]}",
                                    "Region": region,
                                    "District": district,
                                    "Program Name": programName,
                                    "Account Status": "Online"
                                };
                                response.responseMessage = JSON.stringify(userDetails)
                                resolve(response);
                            }

                        },
                            (err) => {
                                response.success = false;
                                if (err.error && err.error.modelState) {
                                    Object.keys(err.error.modelState).forEach(key => {
                                        let errorKey = key.charAt(0).toUpperCase() + key.slice(1)
                                        response.responseMessage = windowObject.parent.translate.instant(errorKey);
                                    });
                                } else {
                                    response.responseMessage = windowObject.parent.translate.instant("SelfRegistration.RequiredFieldValidation");
                                }
                                reject(response);
                            });
                    }
                }
                else if (isError) {
                    response.success = false;
                    response.responseMessage = errorMsg;
                    reject(response);
                }
                else {
                    response.responseMessage = JSON.stringify(userDetails)
                    resolve(response);
                }


            });
            return promise;
        };

        windowObject.parent.postRegistrationCallBack = (userDetails, message) => {
            console.log(userDetails);
            console.log(message);
            let programName = sessionStorage.getItem("programName");
            let referralCode: any = userDetails.attributes.find(x=>x["name"]=="Referral Code");
            if (programName == 'coc') {
                if(typeof(referralCode) !== 'undefined' ){
                    if(referralCode.value !=""){
                    message = windowObject.parent.translate.instant("SelfRegistration.ReferralCode");
                    Swal.fire(message);
                    }
                }
            }
            var data = {
                "userName": userDetails.externalId
            };
            this.PreloginService.bandhanUserCreatedNotifier(data).subscribe();
            this.showLoginPageLink = true;
        };

        this.PreloginService.getSelfRegistrationStatus().subscribe(data => {
            console.log(data);
        });

        this.navigationStartSubscription = this.router.events.pipe(
            filter((event: RouterEvent) => event instanceof NavigationEnd),
            startWith('Initial call')
        ).subscribe((res) => {
            this.browserRefresh = browserRefresh;
            this.getConfig();
        });

        this.languageChangeSubscription = this.translateService.onLangChange.subscribe((event: LangChangeEvent) => {
            if (!this.browserRefresh) {
                window.location.reload();
            }
            else
                this.browserRefresh = false;
        });
    }

    getConfig() {
        this.selectedCulture = localStorage.getItem('culture');
        this.PreloginService.selfRegistrationConfig().subscribe(data => {
            this.renderForm(data);
        })
    }

    renderForm(configs) {
        this.PreloginService.selfRegistration(configs, this.selectedCulture).subscribe(data => {
            this._window.__selfRegistrationAppData__ = data;
            this._window.loadSelfRegistrationInDom('selfRegistrationRoot');
        });
    }

    redirect() {
        this.router.navigate(['/'])
            .then(() => {
                window.location.reload();
            });
    }

    ngOnDestroy() {
        if (this.languageChangeSubscription)
            this.languageChangeSubscription.unsubscribe();
        if (this.navigationStartSubscription)
            this.navigationStartSubscription.unsubscribe();
    }
}